import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import {
  Tabs,
  recordsContain,
  useQueryTabs,
} from '@frontendmentorio/design-system-v2';

import LockedCard from '../LockedCard';
import New from './New';
import Submitted from './Submitted';

export default function Submit({ challenge }) {
  const { activeTab, handleChange, options } = useQueryTabs(
    [
      {
        label: 'New solution',
        value: 'new',
      },
      {
        label: 'My solutions',
        value: 'submitted',
      },
    ],
    { isSub: true }
  );

  const currentUser = useSelector(selectCurrentUser);
  const isUnlocked = recordsContain(currentUser?.unlockedHubs, challenge);

  return (
    <>
      {isUnlocked ? (
        <div className="container-xl flex flex-col gap-6 items-start">
          <Tabs
            activeTab={activeTab}
            ariaLabel="Submit new solution or view your solutions"
            onChange={handleChange}
            options={options}
          />

          <New challenge={challenge} isActive={activeTab === 'new'} />

          <Submitted
            challenge={challenge}
            isActive={activeTab === 'submitted'}
          />
        </div>
      ) : (
        <LockedCard
          CTA="Start challenge"
          href={`/challenges/${challenge.slug}`}
        >
          Start this challenge to submit a solution
        </LockedCard>
      )}
    </>
  );
}
